import React, { FC, ReactElement, useCallback } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { AddressType } from '../../core/apiTypes';
import SvgIcon from '../icons/SvgIcon';
import { IconAxel } from '../../resources/images';
import { clsx } from 'clsx';
import { useTheme } from '../../context/ThemeContext';

interface AddressIconTypeProps {
    type: AddressType | string;
    size?: 'inherit' | 'medium' | 'default' | 'small' | 'large';
    color?: 'lightGrey' | 'black';
}

const AddressIconType: FC<AddressIconTypeProps> = ({ type, size = 'medium', color = 'lightGrey' }): ReactElement => {
    const classes = useStyles();
    const { mode } = useTheme();

    const getIconType = useCallback((): JSX.Element => {
        const classNames = clsx(classes[size], size !== 'inherit' && classes[color]);
        switch (type) {
            case AddressType.FAVORITE:
                return <SvgIcon icon={IconAxel.Star} className={classNames} />;
            case AddressType.WORK:
                return <SvgIcon icon={IconAxel.Briefcase} className={classNames} />;
            case AddressType.HOME:
                return <SvgIcon icon={IconAxel.Home} className={classNames} />;
            case AddressType.AIRPORT:
                return <SvgIcon icon={IconAxel.Plane} className={classNames} />;
            case AddressType.STATION:
                return <SvgIcon icon={IconAxel.Train} className={classNames} />;
            case AddressType.RECENT:
                return <SvgIcon icon={IconAxel.Clock} className={classNames} />;
            case 'driver':
                return <SvgIcon icon={IconAxel.Driver} className={clsx(classNames, classes.fill)} />;
            case 'locate':
                return <SvgIcon icon={IconAxel.Geolocalisation} className={classNames} />;
            default:
                return <SvgIcon icon={IconAxel.Localisation} className={classNames} />;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type, size, mode]);

    return getIconType();
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        small: {
            width: 15,
        },
        medium: {
            width: 20,
        },
        large: {
            width: 24,
        },
        black: {
            stroke: theme.palette.colors.icon.primary,
            fill: 'none',
        },
        lightGrey: {
            stroke: theme.palette.colors.icon.lightGrey,
            fill: 'none',
        },
        fill: {
            fill: theme.palette.colors.icon.primary,
            stroke: 'none',
            '& path': {
                fill: 'inherit',
                stroke: 'none',
            },
        },
        inherit: {
            width: 'inherit',
            fill: 'inherit',
            stroke: 'inherit',
        },
    }),
);

export default AddressIconType;
